import styled from 'styled-components';

interface MavieRankProps {
  isNext: boolean;
}

export const MavieRank = styled.div`
  box-shadow: ${(props) => props.theme.shadows.shadowXS};
  width: 100%;
  display: flex;
  flex-direction: column;
  > div {
    width: 100%;
    padding: 32px;
  }
  > img {
    width: 100%;
  }
  border-radius: 15px;
  margin-bottom: 40px;
  @media (max-width: 800px) {
    border-radius: 8px;
    margin-bottom: 20px;
    > div {
      padding: 20px;
    }
  }
  overflow: hidden;
  background: ${(props) => props.theme.colors.neutral50};
  @media (max-width: 800px) {
    box-shadow: none;
    border-radius: 0;
    width: calc(100% + 40px);
    margin: 0 -20px;
  }
`;
export const CheckboxRank = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  margin-right: 8px;
  background: ${(props) => props.color};
  border-radius: 50%;
  flex: none;
`;
export const CheckboxButton = styled.div`
  cursor: pointer;
  width: 100%;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  > div {
    height: 47px;
    display: flex;
    align-items: center;
  }
  img {
    margin-right: 16px;
    width: 24px;
  }
`;
export const TierBars = styled.div`
  display: flex;
  gap: 6px;
  width: 100%;
`;
export const TierReward = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
  margin-bottom: 10px;
  > span {
    flex: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 31px;
    height: 31px;
    background: ${(props) => props.color};
    border-radius: 50%;
  }
`;
export const PromotionStartEnd = styled.div`
  display: flex;
  justify-content: space-evenly;
`;
export const TierCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 43px;
  height: 43px;
  background: ${(props) => props.color};
  border-radius: 50%;
  margin-bottom: 14px;
  @media (max-width: 800px) {
    margin-bottom: 0;
  }
`;

interface ArrowTierProps {
  hasCondition: boolean;
}

export const ArrowTier = styled.div<ArrowTierProps>`
  height: 1px;
  border-bottom: 1px dashed
    ${(props) =>
      props.hasCondition
        ? props.theme.colors.primary900
        : props.theme.colors.neutral400};
  margin: 0 20px;
`;

interface CountdownNumbersProps {
  ticketPromotion: boolean;
}

export const CountdownNumbers = styled.div<CountdownNumbersProps>`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  > div {
    width: 40px;
    margin: 7px;
    display: flex;
    flex-direction: column;
    align-items: center;
    div {
      color: ${(props) => (props.ticketPromotion ? '#9062ff' : '#dbcea2')};
    }
    @media (max-width: 800px) {
      width: calc(25% - 30px);
    }
  }
  img {
    width: 100%;
  }
`;

export const TicketsWrapper = styled.div`
  width: 645px;
  @media (max-width: 800px) {
    width: 100%;
  }
`;

export const TicketStyled = styled.div`
  cursor: pointer;
  position: relative;
  border-radius: 10px;
  width: 100%;
  box-shadow: ${({ theme }) => theme.shadows.shadowXS};
  margin-bottom: 16px;
  background-color: ${({ theme }) => theme.colors.neutral0};

  transition: all 300ms ease;

  > div:first-child {
    border-radius: 10px;
    display: flex;
    transition: all 300ms ease;
  }

  > div > div:nth-child(2) {
    width: 100%;
    padding: 24px;
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }

  @media (max-width: 800px) {
    background-color: ${({ theme }) => theme.colors.secondaryBlue};
    > div:first-child {
      background-color: ${({ theme }) => theme.colors.neutral0};
    }

    > div > div:nth-child(2) {
      padding: 16px;

      > div:nth-child(1) {
        width: 100%;
      }

      > div:nth-child(2) {
        display: none;
      }
    }
  }
`;

export const TicketImage = styled.div<{ image: any }>`
  width: 170px;
  display: flex;
  flex-grow: 1;
  border-radius: 10px;
  flex: none;
  background: url(${({ image }) => image});
  background-position: top center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding: 20px;

  @media (max-width: 800px) {
    width: 140px;
    background-position: top center;
  }
`;
